import React from 'react';

const rowSpcBtw = (): React.CSSProperties => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };
};

export default rowSpcBtw;
